import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'googleAnalyticsKey',
  initialState: null as string | null,
  reducers: {
    setGoogleAnalyticsKey(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setGoogleAnalyticsKey } = slice.actions;

export default slice.reducer;
